import * as types from './mutations-types'
import {DOWNLOAD_FILE} from '../../../../../common/utils/uploadFileUtil'
export default {
  [types.PRODUCT_DETAILS] (state, data) {
    console.log('detalis', data)
    if(data){
      let codeToFileIds = data.codeToFileIds
      let imgList = []
      if (codeToFileIds && codeToFileIds.details) {
        codeToFileIds.details.filter((itemTwo, indexTwo) => {
          let img = `${DOWNLOAD_FILE}${itemTwo}?X-Authorization=${localStorage.getItem('token')}`
          imgList.push(img)
        })
      }
      codeToFileIds.details = imgList
      let imgCarouselList = []
      if (codeToFileIds && codeToFileIds.carousel) {
        codeToFileIds.carousel.filter((itemTwo, indexTwo) => {
          let img = `${DOWNLOAD_FILE}${itemTwo}?X-Authorization=${localStorage.getItem('token')}`
          imgCarouselList.push(img)
        })
      }
      codeToFileIds.carousel = imgCarouselList
      data.codeToFileIds = codeToFileIds
      if (data.description) {
        try {
          data.description = JSON.parse(data.description).description
        } catch (e) {
          console.error('description', e)
        }
      }
      
      state.productDetailsInfo = data
    }else{
      console.error('data', data)
    };
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-order/store/mutations.js